export default __webpack_public_path__ + "static/media/section1.441726f8.jpg";